'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jsonpP;

var _jsonp = require('jsonp');

var _jsonp2 = _interopRequireDefault(_jsonp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * jsonpP
 *
 * @param {String} url Request url.
 * @param {Object} config jsonp config options.
 *   https://github.com/webmodules/jsonp#jsonpurl-opts-fn
 *     param: 'callback',
 *     timeout: 60000,
 *     prefix: '__jp',
 *     name: prefix + Incremented counter
 * @returns {Object} { promise, cancel }
 */
function jsonpP(url, config) {
  var cancel = void 0;
  var promise = new Promise(function (resolve, reject) {
    var originalCancel = (0, _jsonp2.default)(url, config, function (err, res) {
      if (err) {
        reject(err);
      }
      resolve(res);
    });
    cancel = function cancel() {
      originalCancel();
      reject(new Error('Canceled'));
    };
  });
  return { promise: promise, cancel: cancel };
} /*!
   * @license jsonp-p
   * (c) sugarshin
   * License: MIT
   */


//////////////////
// WEBPACK FOOTER
// ./~/jsonp-p/lib/index.js
// module id = 307
// module chunks = 0